import { isNativeApp } from "./nativeBridge";

/**
 * Shows Apple/Google's official in-app rating popup once per install,
 * triggered only after genuinely positive moments. The OS itself
 * rate-limits the dialog (max 3x/year on iOS), so this is safe to call.
 */
export async function maybeRequestAppReview(trigger = "generic") {
  if (!isNativeApp()) return;
  try {
    if (localStorage.getItem("app_review_asked")) return;
    localStorage.setItem("app_review_asked", trigger);
  } catch {
    return;
  }
  try {
    const { InAppReview } = await import("@capacitor-community/in-app-review");
    await InAppReview.requestReview();
  } catch {}
}
